/*
**  rui-common-dom-detection.js
**
**  Functions for detecting data attributes in DOM that communicate context
*/
export function ruiIsDataDense() {
    return document.body.hasAttribute('data-rui-dense');
}
export function ruiIsFixedLayout() {
    return document.body.hasAttribute('data-rui-fixed-layout');
}
export function ruiIsFixedLayoutVerticalScrolling() {
    return document.body.hasAttribute('data-rui-fixed-layout-vertical-scrolling');
}
